import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.99625 16.2928H5.33122C5.68499 16.293 6.02435 16.1527 6.27461 15.9026V15.9026C6.52465 15.6524 6.665 15.313 6.66477 14.9592V9.62301C6.665 9.26924 6.52465 8.92988 6.27461 8.67961V8.67961C6.02435 8.42958 5.68499 8.28923 5.33122 8.28945H2.99625"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.0038 8.28945H18.6698C18.316 8.28923 17.9767 8.42958 17.7264 8.67961V8.67961C17.4764 8.92988 17.336 9.26924 17.3362 9.62301V14.9592C17.336 15.313 17.4764 15.6524 17.7264 15.9026V15.9026C17.9767 16.1527 18.316 16.293 18.6698 16.2928H21.0038"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3562 15.1893H16.4959C16.2097 15.1891 15.9268 15.2505 15.6665 15.3694L11.4578 17.2862"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6444 9.20784C10.1377 8.90775 9.52405 8.84766 8.96874 9.04377L6.66779 9.87311"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4963 8.97574L14.6191 7.70921C14.0025 7.43785 13.2907 7.495 12.7253 7.86127L10.1142 9.55298C9.72182 9.8073 9.46975 10.2294 9.43194 10.6955C9.39413 11.1615 9.57487 11.6187 9.92113 11.933V11.933C10.3706 12.34 11.0202 12.4381 11.5698 12.1821L13.1265 11.4558"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1265 11.4548L13.9168 12.1721C14.334 12.5501 14.5727 13.0864 14.5742 13.6494C14.5757 14.2124 14.34 14.75 13.9248 15.1303L11.907 16.9771C11.1453 17.6742 9.97816 17.6773 9.21285 16.9841L7.82627 15.7266C7.49696 15.4338 7.08024 15.258 6.64078 15.2263"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x={2.99625}
      y={2.99625}
      width={18.0075}
      height={18.0075}
      rx={4}
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgComponent
